/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { GroupOutlined } from '@ant-design/icons';

import { NodeGroup } from '@/client';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Card } from '@/primitives/Card';
import { Flex } from '@/primitives/Flex';
import { Text } from '@/primitives/Text';
import { Title } from '@/primitives/Title';

export type UpdateFleetConfigFleetDetailsProps = {
  nodeGroup: NodeGroup;
};

export function UpdateFleetConfigFleetDetails({ nodeGroup }: UpdateFleetConfigFleetDetailsProps) {
  const { t } = useMimicTranslation('fleets');

  return (
    <Card padding="sm" bordered>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8em' }}>
        <Text type="subtle" strong size="md">
          {t('updateConfigDrawer.fleet')}
        </Text>
        <Flex vertical full gap="xxs">
          <Title style={{ fontWeight: 500 }} level={4}>
            <GroupOutlined /> {nodeGroup.name}
          </Title>
          <Text type="subtle" size="md" copyable mono>
            {nodeGroup.id}
          </Text>
        </Flex>
      </div>
    </Card>
  );
}
